import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';

import type { TypeCtaSkeleton } from './TypeCta';
import type { TypeQuickLinkSkeleton } from './TypeQuickLink';

export interface TypeBlockQuickLinkFields {
    internalName: EntryFieldTypes.Symbol;
    title?: EntryFieldTypes.Symbol;
    displayOption?: EntryFieldTypes.Symbol<'card with image' | 'card with links' | 'card' | 'link'>;
    colorOption?: EntryFieldTypes.Symbol<'primary' | 'secondary'>;
    quickLinks?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeQuickLinkSkeleton>>;
    cta?: EntryFieldTypes.EntryLink<TypeCtaSkeleton>;
}

export type TypeBlockQuickLinkSkeleton = EntrySkeletonType<TypeBlockQuickLinkFields, 'blockQuickLink'>;
export type TypeBlockQuickLink<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockQuickLinkSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockQuickLink<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: unknown,
): entry is TypeBlockQuickLink<Modifiers, Locales> {
    const candidate = entry as { sys?: { contentType?: { sys?: { id?: string } } } };

    return candidate.sys?.contentType?.sys?.id === 'blockQuickLink';
}
